<script>
import { layoutMethods, erpUserRolesMethods, erpUserRolesComputed } from "@/state/helpers";
import Swal from 'sweetalert2';
// import { modulesList } from './data-list';
import { getModuleAccess } from '@/router/helper.js'

export default {
  page: {
    title: "Manage Role",
  },
  data() {
    return {
      action: "",
      roleName: "",
      role: {
        name: "",
        description: "",
        isActive: "0",
        modules: [],
        userCount: 0
      },
      submitted: false,
      rolesModule: {
				access: {
          update: true
				}
			},
    };
  },
  mounted: async function () {
    this.action = this.$route.params.action;
    this.changeTitle({ title: `${this.action.charAt(0).toUpperCase() + this.action.slice(1)} Role` });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Roles", to: { name: "Roles" } },
        {
          text: `${this.action.charAt(0).toUpperCase() + this.action.slice(1)} Role`,
          to: { name: "" }
        }
      ],
    });

    // this.role.modules = JSON.parse(JSON.stringify(modulesList))

    // get role settings/structure from the table
    await this.getRoleSettings()
    .then((data) => this.role.modules = JSON.parse(data[0].option_value));

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'User Management', 'Roles')
    .then((access) => this.rolesModule.access = access);

    // if received action is edit, we'll fetch the role details from the database 
    // to set the access values based on existing role
    if (this.action == 'edit') {
      await this.getRoleById();
    }

    // set the isActive into 1 if the action is add new role to default the status value into active
    if (this.action == 'add') {
      this.role.isActive = '1'
    }
  },
  computed: {
    ...erpUserRolesComputed,
  },
  methods: {
    ...layoutMethods,
    ...erpUserRolesMethods,
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Date:		    November 29, 2022
    *  Description:	getRoleById - This function will fetch the role details from database
    *  Params:		  roleId
    */
    getRoleById: async function () {
      await this.readRole({
        body: { roleId: this.$route.params.id }
      }).then(() => {
        this.role.name = this.rolesList[0].name;
        this.role.description = this.rolesList[0].description;
        // this.role.modules = JSON.parse(this.rolesList[0].access);
        this.role.isActive = this.rolesList[0].is_active;
        this.role.userCount = this.rolesList[0].user_count;
        let rolesAccess = JSON.parse(this.rolesList[0].access);

        // this loop will dynamically add newly added category, 
        // modules, or submodules to the list/array of modules
        for (let i = 0; i < this.role.modules.length; i++) {
          for (let j = 0; j < rolesAccess.length; j++) {
            if (this.role.modules[i].id == rolesAccess[j].id) {
              this.role.modules[i].enabled = rolesAccess[j].enabled;
              for (let k = 0; k < this.role.modules[i].modules.length; k++) {
                for (let l = 0; l < rolesAccess[j].modules.length; l++) {
                  if (this.role.modules[i].modules[k].id == rolesAccess[j].modules[l].id) {
                    this.role.modules[i].modules[k].enabled = rolesAccess[j].modules[l].enabled;
                    if (this.role.modules[i].modules[k].submodules.length > 0) {
                      for (let m = 0; m < this.role.modules[i].modules[k].submodules.length; m++) {
                        for (let n = 0; n < rolesAccess[j].modules[l].submodules.length; n++) {
                          if (this.role.modules[i].modules[k].submodules[m].id == rolesAccess[j].modules[l].submodules[n].id) {
                            this.role.modules[i].modules[k].submodules[m] = rolesAccess[j].modules[l].submodules[n];
                          }
                        }
                      }
                    } else {
                      this.role.modules[i].modules[k] = rolesAccess[j].modules[l]
                    }
                  }
                }
              }
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
        Swal.fire(
          "Error",
          "An error encountered while retrieving role.",
          "error"
        ).then(() => {
          this.$router.back();
        })
      });
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Date:		    November 29, 2022
    *  Description:	submitRole - This function will submit the newly added role or updated role
    */
    submitRole() {
      this.submitted = true
      console.log('submitted role: ', this.role.modules)

      if (this.role.name != "") {
        this.manageRole({
          action: this.action == "add" ? "create" : "edit",
          body: {
            id: this.$route.params.id,
            roleName: this.role.name,
            roleDescription: this.role.description,
            roleAccess: JSON.stringify(this.role.modules),
            roleStatus: this.role.isActive,
            createdBy: this.action == "add" ? JSON.parse(localStorage.getItem("userData")).email : null,
            updatedBy: this.action == "edit" ? JSON.parse(localStorage.getItem("userData")).email : null
          }
        }).then(() => {
          Swal.fire(
            this.action == "add" ? "Added Successfully!" : "Role Updated Successfully!",
            this.action == "add" ? `${this.role.name} has been created.` : "",
            "success"
          ).then(() => {
            // this.$router.back();
            location.reload();
          }); 
        }).catch(function (error) {
          Swal.fire(
            "Failed! ",
            error,
            "warning"
          );
          console.log(error);
        });
      } else {
        Swal.fire(
          "Role name is empty.",
          "Please enter a role name.",
          "warning"
        );
      }
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Description:	checkIfHasProp - This function will check if a module has approver or requester properties.
    *               This is being used to check if we are going to hide the table headers for approver and requester
    *               toggle.
    *  Params:      category and specific property
    */
    checkIfHasProp(category, prop) {
      // loop thru every modules in the category
      for (let module of category.modules) {
        // check if module has submodules, if yes, we'll loop thru the submodules
        if (module.submodules.length > 0) {
          for (let submodule of module.submodules) {
            // check if a submodule has the property
            if (Object.hasOwn(submodule.access, prop)) {
              return true;
            }
          }
        } else if (module.submodules.length == 0) {
          // check if a module has the property
          if (Object.hasOwn(module.access, prop)) {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Description:	onToggle - This function will toggle on/off all modules under a category.
    *  Params:      category and category index
    */
    onToggle(category, catIndex) {
      // get the value of parent toggle using the ref name
      const action = this.$refs[`${category.id}_parent_toggle`][0].checked

      // loop thru every modules and submodules under the category
      for (let i = 0; i < category.modules.length; i++) {
        // check if the module has submodules, if yes, loop thru the submodules array
        if (category.modules[i].submodules.length > 0) {
          for (let j = 0; j < category.modules[i].submodules.length; j++) {
            // set the submodules toggle into category toggle value
            this.role.modules[catIndex].modules[i].submodules[j].access.create = action
            this.role.modules[catIndex].modules[i].submodules[j].access.read = action
            this.role.modules[catIndex].modules[i].submodules[j].access.update = action
            this.role.modules[catIndex].modules[i].submodules[j].access.delete = action
            this.role.modules[catIndex].modules[i].enabled = action

            if (Object.hasOwn(this.role.modules[catIndex].modules[i].submodules[j].access, 'approver')) 
              this.role.modules[catIndex].modules[i].submodules[j].access.approver = action
            if (Object.hasOwn(this.role.modules[catIndex].modules[i].submodules[j].access, 'requester'))
            this.role.modules[catIndex].modules[i].submodules[j].access.requester = action
          }
        } else {
          // set the parent module toggle into parent toggle value
          this.role.modules[catIndex].modules[i].access.create = action
          this.role.modules[catIndex].modules[i].access.read = action
          this.role.modules[catIndex].modules[i].access.update = action
          this.role.modules[catIndex].modules[i].access.delete = action
        }
      }
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Description:	onParentModuleToggle - This function will toggle on/off all submodules under a parent module.
    *  Params:      category index, module object, module index, value (true or false)
    */
    onParentModuleToggle(catIndex, module, index, value){
      // loop thru the submodules
      for (let i = 0; i < module.submodules.length; i++) {
        // set the submodules toggle into parent toggle value
        this.role.modules[catIndex].modules[index].enabled = value;
        this.role.modules[catIndex].modules[index].submodules[i].access.create = value
        this.role.modules[catIndex].modules[index].submodules[i].access.read = value
        this.role.modules[catIndex].modules[index].submodules[i].access.update = value
        this.role.modules[catIndex].modules[index].submodules[i].access.delete = value

        if(Object.hasOwn(this.role.modules[catIndex].modules[index].submodules[i].access, 'approver'))
          this.role.modules[catIndex].modules[index].submodules[i].access.approver = value
          if(Object.hasOwn(this.role.modules[catIndex].modules[index].submodules[i].access, 'requester'))
          this.role.modules[catIndex].modules[index].submodules[i].access.requester = value
      }
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Description:	toggleRead - This function will toggle on/off the read toggle of a module/submodule.
    *               This is based on the condition that if the update toggle is on, the read toggle should
    *               be automatically toggled on
    *  Params:      category index, module index, submodule index, value (true or false)
    */
    toggleRead(catIndex, moduleIndex, subIndex, value) {
      // check if subIndex is null, if yes, meaning the received object is a submodule
      if (subIndex == null) {
        // initial element using ref name
        let element = this.$refs[`${catIndex}_${moduleIndex}_read`][0]
        // value is true, we'll toggle on the read toggle and then disable it
        if (value) {
          this.role.modules[catIndex].modules[moduleIndex].access.read = true;
          element.checked = true;
          element.setAttribute('disabled', true);
        }
        // else, we'll remove the disable attrib
        else {
          this.role.modules[catIndex].modules[moduleIndex].access.read = true;
          element.checked = true;
          element.removeAttribute('disabled');
        }
      } 
      // the receive object is a module
      else {
        // initial element using ref name
        let element = this.$refs[`${catIndex}_${moduleIndex}_${subIndex}_read`][0]
        // value is true, we'll toggle on the read toggle and then disable it
        if (value) {
          this.role.modules[catIndex].modules[moduleIndex].submodules[subIndex].access.read = true;
          element.checked = true;
          element.setAttribute('disabled', true);
        } 
        // else, we'll remove the disable attrib
        else {
          this.role.modules[catIndex].modules[moduleIndex].submodules[subIndex].access.read = true;
          element.checked = true;
          element.removeAttribute('disabled');
        }
      }
    },
    toggleModuleStatus(module) {
      for (let prop in module.access) {
        if (module.access[prop] == true) {
          module.enabled = true;
          break;
        } else {
          module.enabled = false;
        }
      }
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <form class="px-4 py-3">
                <b-container>
                  <label v-if="action == 'edit' && !rolesModule.access.update" 
                    class="form-label medium fw-bold text-danger mb-2" 
                      style="padding-bottom: 10px;">
                          Note: Your access is limited. You cannot update a Role.
                  </label>
                  <b-row>
                    <b-col sm>
                      <div class="mb-5">
                        <label class="form-label">Role Name</label>
                        <input type="text" class="form-control" style="width: 100%;" v-model="role.name"
                          id="addcontact-name-input" placeholder="Enter Role"
                          :class="{ 'is-invalid': submitted && role.name == '', }" />
                        <div v-if="submitted && role.name == ''" class="invalid-feedback">
                          Role Name is required.
                        </div>
                      </div>
                    </b-col>
                    <b-col sm>
                      <div class="mb-4" style="padding-left: 7px;">
                        <label class="form-label">Description</label>
                        <input type="text" class="form-control" style="width: 100%;" v-model="role.description"
                          id="addcontact-name-input" placeholder="Enter Description" />
                      </div>
                    </b-col>
                    <b-col sm>
                      <div class="mb-4" style="padding-left: 7px;">
                        <label class="form-label">Status</label>
                        
                        <div class="form-check form-switch form-switch-md me-3 mb-0" style="padding-top: 4px;" id="statusToggle">
                          <input class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch"
                            id="statusToggle" :checked="role.isActive == '1' ? true : false"
                            @click="role.isActive = role.isActive == '0' ? '1' : '0'" :disabled="role.userCount > 0">
                          <label class="form-label" style="font-size: 14px; padding-bottom: 2px;">{{role.isActive == '1' ? 'Enabled' : 'Disabled'}}</label>
                          <b-tooltip v-if="role.userCount > 0"
                            target="statusToggle" triggers="hover" 
                            variant="light" placement="topleft">
                            <label class="text-danger" style="font-size: 12px; line-height: normal;">
                              You cannot disable this role. This is already assigned to a user. 
                            </label>
                          </b-tooltip>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
                <div v-for="(category, categoryIndex) in role.modules" 
                  :key="categoryIndex"
                  class="table-responsive"
                  style="margin-bottom: 0px;">
                  <div class="align-middle table-nowrap card border shadow-none mb-5">
                    <div class="card-header d-flex align-items-center" style="border-bottom-width: 0px;">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                            {{ categoryIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="" style="margin-right: 1rem; width: 79%;">
                        <h5 class="card-title">{{ category.title }}</h5>
                      </div>
                      <div class="form-check form-switch form-switch-md align-middle" dir="ltr">
                        <label 
                          class="form-check-label" 
                          for="customSwitchsizelg" 
                          style="font-size: 16px; padding-bottom: 2px;">
                            Status
                        </label>
                        <input type="checkbox" class="form-check-input" :ref="`${category.id}_parent_toggle`"
                          @change="onToggle(category, categoryIndex)" v-model="category.enabled" style="margin-top: 5px;"/>
                      </div>
                    </div>
                    <table class="table table-hover">
                      <thead>
                        <tr style="border-top-width: 1px;">
                          <th scope="col">Module</th>
                          <th scope="col">Create</th>
                          <th scope="col">Read</th>
                          <th scope="col">Update</th>
                          <th scope="col">Delete</th>
                          <th scope="col" v-if="checkIfHasProp(category, 'approver')">Approver</th>
                          <th scope="col" v-if="checkIfHasProp(category, 'requester')">Requester</th>
                        </tr>
                      </thead>
                      <tbody v-for="(module, moduleIndex) in category.modules" :key="module.id">
                        <tr v-if="module.submodules.length == 0" style="border-top-width: 1px; border-bottom-width: 0px;">
                          <td style="border-bottom-width: 0px;">
                            <span class="text-body fw-medium m-0">{{ module.name }}</span>
                          </td>
                          <td style="border-bottom-width: 0px;">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_create`" v-if="Object.hasOwn(module.access, 'create')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].access.create" class="form-check-input"
                                v-b-toggle="'collapse-3'" type="checkbox" role="switch" :disabled="!category.enabled"
                                id="flexSwitchCheckDefault1" @change="toggleModuleStatus(module)">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0px;">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_read`" v-if="Object.hasOwn(module.access, 'read')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].access.read" class="form-check-input"
                                v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || role.modules[categoryIndex].modules[moduleIndex].access.update"
                                @change="toggleModuleStatus(module)">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0px;">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_update`" v-if="Object.hasOwn(module.access, 'update')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].access.update" class="form-check-input"
                                v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled" @change="toggleModuleStatus(module); toggleRead(categoryIndex, moduleIndex, null, role.modules[categoryIndex].modules[moduleIndex].access.update);">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0px;">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_delete`" v-if="Object.hasOwn(module.access, 'delete')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].access.delete" class="form-check-input"
                                v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled" @change="toggleModuleStatus(module)">
                            </div>
                          </td>
                        </tr>
                        <tr v-if="module.submodules.length > 0" style="border-bottom-width: 0; border-top-width: 1px;">
                          <td style="border-bottom-width: 0; display: inline-flex;">
                            <label class="text-body fw-medium m-0">{{ module.name }}</label>
                            <span class="form-check form-switch" style="margin-left: 15px;">
                              <input class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" 
                                    role="switch" id="flexSwitchCheckDefault1" 
                                    v-model="role.modules[categoryIndex].modules[moduleIndex].enabled"
                                    :disabled="!category.enabled" 
                                    @change="onParentModuleToggle(categoryIndex, module, moduleIndex, role.modules[categoryIndex].modules[moduleIndex].enabled)">
                            </span>
                          </td> 
                        </tr>
                        <tr v-for="(submodule, subIndex) in module.submodules" :key="subIndex" style="border-bottom-width: 0">
                          <td style="border-bottom-width: 0">
                            <span class="text-body fw-medium m-20" style="margin-left: 10px;">
                              {{ submodule.name }}
                            </span>
                          </td>
                          <td style="border-bottom-width: 0">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_${subIndex}_create`" v-if="Object.hasOwn(submodule.access, 'create')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.create"
                                class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || !role.modules[categoryIndex].modules[moduleIndex].enabled"
                                @change="toggleModuleStatus(submodule)">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_${subIndex}_read`" v-if="Object.hasOwn(submodule.access, 'read')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.read"
                                class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || !role.modules[categoryIndex].modules[moduleIndex].enabled || role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.update"
                                @change="toggleModuleStatus(submodule)">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_${subIndex}_update`" v-if="Object.hasOwn(submodule.access, 'update')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.update"
                                class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || !role.modules[categoryIndex].modules[moduleIndex].enabled"
                                @change="toggleModuleStatus(submodule); toggleRead(categoryIndex, moduleIndex, subIndex, role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.update);">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_${subIndex}_delete`" v-if="Object.hasOwn(submodule.access, 'delete')"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.delete"
                                class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || !role.modules[categoryIndex].modules[moduleIndex].enabled"
                                @change="toggleModuleStatus(submodule)">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0" v-if="Object.hasOwn(submodule.access, 'approver')">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_${subIndex}_approver`"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.approver"
                                class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || !role.modules[categoryIndex].modules[moduleIndex].enabled"
                                @change="toggleModuleStatus(submodule)">
                            </div>
                          </td>
                          <td style="border-bottom-width: 0" v-if="Object.hasOwn(submodule.access, 'requester')">
                            <div class="form-check form-switch me-3 mb-0">
                              <input :ref="`${categoryIndex}_${moduleIndex}_${subIndex}_requester`"
                                v-model="role.modules[categoryIndex].modules[moduleIndex].submodules[subIndex].access.requester"
                                class="form-check-input" v-b-toggle="'collapse-3'" type="checkbox" role="switch" id="flexSwitchCheckDefault1"
                                :disabled="!category.enabled || !role.modules[categoryIndex].modules[moduleIndex].enabled"
                                @change="toggleModuleStatus(submodule)">
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="text-end mt-3">
                  <b-button :disabled="action == 'add' ? !rolesModule.access.create : !rolesModule.access.update" type="button" variant="primary" class="w-sm" @click="submitRole()">Submit</b-button>
                  <!-- <b-button type="button" variant="primary" class="w-sm" @click="submitRole()">Submit</b-button> -->
                  <b-button variant="light" class="w-sm ms-2" @click="$router.back()">Close</b-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
